// What an iPhone uses when someone adds the app to their Home Screen: the
// club's name and logo, read at that moment. Without a logo, the site's own
// icon. Android and computers use the site's manifest.
import { isAdminSite, isPlatformSite } from './adminSite';

export function applyHomeScreenIdentity({ clubName, logoUrl } = {}, hostname = window.location.hostname) {
  const rtc = isPlatformSite(hostname) || isAdminSite(hostname);
  const set = (id, attr, value) => { const el = document.getElementById(id); if (el && value) el.setAttribute(attr, value); };
  set('manifest', 'href', rtc ? '/manifest-rtc.json' : '/manifest.json');
  set('apple-title', 'content', clubName || (rtc ? 'Run The Club' : 'Trampoline Life'));
  // iPhones round the icon's corners themselves: these are square, with the
  // artwork inset so the rounding doesn't cut it off
  // (the admin site is always Run The Club's, whoever is signed in)
  const icon = isAdminSite(hostname) ? '/rtc-admin-touch-icon.png'
    : logoUrl || (rtc ? '/rtc-touch-icon.png' : '/tl-touch-icon.png');
  set('apple-touch-icon', 'href', icon);
}
